import { Contact, Product } from "@/models/base";
import { AwsDocument } from "@/models/base/aws-document";
import { v4 } from "uuid";

export enum ModalType {
	IFRAME = "iframe",
	CONTACT_EDIT = "contact-edit",
	PRODUCT_EDIT = "product-edit"
}

export interface IModal {
	uid:string;
	type:ModalType;
	data:any;
	title?:string;
	options:any;
	width?:number;
	height?:number;
	callback?:Function;
}

export interface IFrameModalOptions {
	padded?:boolean;
	width?:number;
	height?:number;
	plain?:boolean;
	subtitle?:string;
}

export interface ICreateProductModalOptions{
	skuDisabled?:boolean;
}

export class ModalServiceClass {
	public modals:IModal[] = [];
	public openImages:string[] = [];
	public openImageLists:string[][] = [];
	public openedAwsDocumentStates:AwsDocument[][] = [];

	public openIframeModal(link:string, title:string, options:IFrameModalOptions = {}){
		this.modals.push({type: ModalType.IFRAME, data: link, title, uid: v4(), options, width: options.width, height: options.height});
	}

	public openImageUrl(imageUrl:string){
		if (!imageUrl) return;
		this.openImages.push(imageUrl);
	}

	public openImageUrlList(imageUrls:string[]){
		if (imageUrls.length == 0) return;
		this.openImageLists.push(imageUrls);
	}

	public openAwsDocuments(documents:AwsDocument[]) {
		this.openedAwsDocumentStates.push(documents);
	}


	public async openEditContactModal(groupId:number, contact?:Contact):Promise<Contact | null>{
		return new Promise((resolve)=>{
			this.modals.push({
				type: ModalType.CONTACT_EDIT,
				data: {
					contact,
					groupId
				},
				options: {},
				callback: resolve,
				uid: v4()
			});
		});
	}

	public async openCreateProductModal(product?:Product, options:ICreateProductModalOptions = {}):Promise<Product | null>{
		return new Promise((resolve)=>{
			this.modals.push({
				type: ModalType.PRODUCT_EDIT,
				data: {
					product,
					options
				},
				options: {},
				callback: resolve,
				uid: v4()
			});
		});
	}
}

export const ModalService = new ModalServiceClass();